









import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { EssencesApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';

@Component
export default class EssenceHideButton extends Vue {
  public isEssenceShown = true;

  get visibility(): string {
    return this.isEssenceShown ? 'visibility' : 'visibility_off';
  }

  get visibilityText(): string {
    return this.isEssenceShown ? this.$t('essential.essenceHideButton.visibleOnEssenceList').toString() :
      this.$t('essential.essenceHideButton.hiddenOnEssenceList').toString();
  }

  @Prop({ required: true })
  public sku: string;

  @Prop({ required: true })
  public isEssential: boolean;

  private api = ApiService.wrap(EssencesApi);

  public mounted() {
    this.isEssenceShown = this.isEssential;
  }

  public toggleEssenceVisibility() {
    const newVisibility = !this.isEssenceShown;
    this.api
      .setEssenceVisibility(ConfigService.getTenant(), ConfigService.currentCustomerId, this.sku, newVisibility)
      .then(() => {
        this.isEssenceShown = newVisibility;
      })
      .catch(ApiService.defaultErrorHandler);
  }
}
